module.exports = __webpack_public_path__ + "img/1557614063051153410.f4fe7d7e.png";